import { atom } from 'recoil';

// state to control whether the user is loading
const isUserLoadingState = atom({
    key: 'loadingState',
    default: true,
});

export default isUserLoadingState;
